import { render, staticRenderFns } from "./_ProxyStoreGoodsPicker.vue?vue&type=template&id=2667543b&"
import script from "./_ProxyStoreGoodsPicker.vue?vue&type=script&lang=js&"
export * from "./_ProxyStoreGoodsPicker.vue?vue&type=script&lang=js&"
import style0 from "./_ProxyStoreGoodsPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports